import type { IconData } from '@stacksjs/iconify-core'

export const dropbox: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M395 133L161 286L0 150L235 4zm143 493q5 0 10-3l96-63v37L395 754L147 597v-37l96 63q4 3 10 3t12-4l130-109l131 109q6 4 12 4m92-340L395 133L556 4l235 146zm0 0l143 115l-232 152l-146-121zM18 401l143-115l234 146l-145 121z\"/>",
  "width": 800,
  "height": 850,
  "viewBox": "0 0 800 850"
}

export default dropbox
